"use strict";
/**
 * @author arnozhang
 * @date 2019/06/25
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.LogLevel = exports.LogWriter = void 0;
var LogWriter = /** @class */ (function () {
    function LogWriter() {
    }
    LogWriter.prototype.writeLog = function (message) {
        console.log(message);
    };
    LogWriter.prototype.formatLog = function (level, tagOrMessage, message) {
        if (message != null) {
            return level + " [" + tagOrMessage + "]: " + message;
        }
        return level + " " + tagOrMessage;
    };
    return LogWriter;
}());
exports.LogWriter = LogWriter;
var LogLevel;
(function (LogLevel) {
    LogLevel["verbose"] = "Verbose";
    LogLevel["debug"] = "Debug";
    LogLevel["info"] = "Info";
    LogLevel["warn"] = "Warn";
    LogLevel["error"] = "Error";
    LogLevel["fatal"] = "Fatal";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.customizeWriter = function (newWriter) {
        Logger.writer = newWriter;
    };
    Logger.v = function (tagOrMessage, message) {
        Logger._log(LogLevel.verbose, tagOrMessage, message);
    };
    Logger.d = function (tagOrMessage, message) {
        Logger._log(LogLevel.debug, tagOrMessage, message);
    };
    Logger.i = function (tagOrMessage, message) {
        Logger._log(LogLevel.info, tagOrMessage, message);
    };
    Logger.w = function (tagOrMessage, message) {
        Logger._log(LogLevel.warn, tagOrMessage, message);
    };
    Logger.e = function (tagOrMessage, message) {
        Logger._log(LogLevel.error, tagOrMessage, message);
    };
    Logger.f = function (tagOrMessage, message) {
        Logger._log(LogLevel.fatal, tagOrMessage, message);
    };
    Logger._log = function (level, tagOrMessage, message) {
        Logger.writer.writeLog(Logger.writer.formatLog(level, tagOrMessage, message));
    };
    Logger.writer = new LogWriter();
    return Logger;
}());
exports.Logger = Logger;
